module.exports = __webpack_public_path__ + "img/account-new-icon5.accf7243.svg";